<template>
  <v-container>
    <v-card
      :loading="false"
    >
      <v-overlay
        :absolute="true"
        :value="isComponentLoading"
      >
        <v-progress-circular indeterminate size="24"></v-progress-circular>
      </v-overlay>
      <v-row class="pa-3">
        <v-col
          v-if="regionsItems"
          cols="12" md="6">
          <v-select
            v-model="searchParams.region"
            :hint="$t('hints.region')"
            :items="regionsItems"
            persistent-hint
            single-line
            :loading="false"
          ></v-select>
        </v-col>
        <v-col cols="12" md="6">
          <v-menu
            v-model="menuFrom"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="fromDateFormatted"
                @input="changeDate('from', $event)"
                :label="lang($store, 'sap/listings.global.filter.hints.date')"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="searchParams.from" no-title
             :first-day-of-week="1"
             :locale="getCurrentLocale()"
             @input="menuFrom = false"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import searchTextFilter from '@/mixins/filters/searchTextFilter';
import regionsFilter from '@/mixins/filters/regionsFilter';
import isComponentLoading from '../../mixins/isComponentLoading';
/* components */

export default {
  name: 'FilterRevenue',
  mixins: [
    isComponentLoading,
    searchTextFilter,
    regionsFilter,
  ],
  components: {
  },
  props: {
    defaultSearchParams: {
      type: Object,
      default: () => ({
        from: null,
        region: null,
      }),
    },
  },
  data() {
    return {
      menuFrom: false,
      searchParams: {},
    };
  },
  mounted() {
    this.searchParams = {
      from: this.defaultSearchParams.from,
      region: this.defaultSearchParams.region,
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
    fromDateFormatted() {
      return this.formatDate(this.searchParams.from);
    },
  },
  watch: {
    searchParams: {
      handler(newVal) {
        this.$emit('filtering', newVal);
      },
      deep: true,
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    changeDate(type, date) {
      if (date === null) {
        this.searchParams[type] = null;
      }
    },
    getCurrentLocale() {
      return window.localStorage.language;
    }
  },
};
</script>

<style scoped>

</style>
